import "./styles/globals.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { onUnauthorized } from "@/api/client";
import { qk } from "@/api/queries/keys";
import { initRuntime } from "@/api/runtime";
import { createQueryClient } from "@/app/providers/query-client";
import { createAppRouter } from "@/app/router";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

async function start() {
  await initRuntime();
  const queryClient = createQueryClient();
  const router = createAppRouter(queryClient);
  // Session ended mid-use → login, then back to the same page.
  onUnauthorized(() => {
    const { pathname, href } = router.state.location;
    if (pathname === "/login") return;
    queryClient.setQueryData(qk.session(), null);
    void router.navigate({ to: "/login", search: { redirect: href, reason: "expired" }, replace: true });
  });
  const el = document.getElementById("root");
  if (!el) throw new Error("#root missing");
  createRoot(el).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delay={300}>
          <RouterProvider router={router} />
        </TooltipProvider>
        <Toaster position="bottom-right" closeButton />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void start();
